import { Fragment } from "react";
import { Link } from "react-router";

import { CaretRightIcon } from "@radix-ui/react-icons";

import { useURL } from "~/contexts";
import type { PathRecord } from "~/lib/app.types";
import { cn } from "~/lib/ui";

import { Skeleton } from "./ui/skeleton";

export const BreadcrumbsSkeleton = ({ size = 2 }) => {
  return (
    <div className="flex flex-row pb-2">
      <Skeleton className="h-5 w-8" />
      {Array.from({ length: size }, (_, i) => (
        <Fragment key={i}>
          <div className="w-2"></div>
          <Skeleton className="h-5 w-16" />
        </Fragment>
      ))}
    </div>
  );
};
const Breadcrumbs = ({
  categories,
  pageName,
}: {
  categories?: PathRecord[];
  pageName?: string;
}) => {
  const isSale = categories?.[0]?.id === "sale";
  const url = useURL();
  return (
    <div className="no-scrollbar w-full overflow-x-auto pb-2">
      <Link
        to={url("/")}
        className="text-sm font-light text-neutral-11"
        prefetch="intent"
      >
        Home
      </Link>
      {categories &&
        categories.map((category, i) => {
          let link = isSale ? "/shop" : "";
          for (let index = 0; index <= i; index++) {
            link += `/${categories[index]?.id}` || "";
          }
          const disabled =
            !pageName && i === categories.length - 1 && categories.length !== 1;
          return (
            <Link
              key={category?.id ? category.id : category?.name || i}
              to={url(link)}
              className={cn(
                "text-sm font-light text-neutral-11",
                disabled && "pointer-events-none opacity-50",
              )}
            >
              <CaretRightIcon height={12} className="inline" /> {category.name}
            </Link>
          );
        })}
      {pageName && (
        <div className="inline text-sm font-light text-neutral-11 opacity-50">
          {" "}
          <CaretRightIcon height={12} className="inline" /> {pageName}
        </div>
      )}
    </div>
  );
};

export default Breadcrumbs;
